import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-sketch-icon',
  templateUrl: './design-sketch.component.html'
})
export class DesignSketchComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
